import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  // CardBody,
  // CardHeader,
  Col,
  Container,
  // Input,
  // Label,
  Row,
} from "react-bootstrap";
// import { _get, _put } from "../Utils/Helper";
import { useParams, useNavigate } from "react-router-dom";
import { _get, _put } from "../../Utils/Helper";
import { Input } from "antd";
// import { Input } from "antd";

export default function ScoreFeil() {
  const id = useParams().id;
  const navigate = useNavigate(); // Import and define navigate here

  const _form = {
    Mathematics: 0,
    english: 0,
    others: 0,
    admission_no: "",
    name_of_applicant: "",
    class1: "",
  };

  const [form, setForm] = useState(_form);
  const [errors, setErrors] = useState({});
  const [statusColor, setStatusColor] = useState("secondary"); // Default button color
  const [statusText, setStatusText] = useState("Status"); // Default button text

  const handleSubmit = (e: any) => {
    e.preventDefault();
    _put(
      "update_secondary_school_entrance_form",
      { ...form, id, query_type: "update", statusText },
      (res) => {
        // Handle success
        console.log(res);

        // Navigate based on statusText
        if (statusText === "Passed") {
          navigate(`/exams_score/${id}`);
        } else if (statusText === "Failed") {
          navigate(`/score_fail/${id}`);
        }
      },
      (err) => {
        // Handle error
        console.log(err);
      }
    );
  };

  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const getSecScl = useCallback(() => {
    _get(
      `get_secondary_school_entrance_form?id=${id}&query_type=select_id`,
      (res) => {
        // Handle success response
        console.log(res);
        if (res.results.length) {
          setForm(res.results[0]);
        }
      },
      (err) => {
        // Handle error response
        console.log(err);
      }
    );
  }, [id]);

  useEffect(() => {
    getSecScl();
  }, [getSecScl]);

  useEffect(() => {
    const MathematicsScore = form.Mathematics || 0;
    const englishScore = form.english || 0;
    const othersScore = form.others || 0;

    const averageScore = (MathematicsScore + englishScore + othersScore) / 3;
    if (averageScore <= 49) {
      setStatusColor("danger"); // Red button
      setStatusText("Failed"); // Display "Failed"
    } else if (averageScore >= 50 && averageScore <= 100) {
      setStatusColor("success"); // Green button
      setStatusText("Passed"); // Display "Passed"
    }
  }, [form]);

  return (
    <div>
      {/* <Container> */}
      <div className="page-wrapper">
        <div className="content content-two"></div>
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-info-square-rounded fs-16" />
                    </span>
                    <h4 className="text-dark">Personal Information</h4>
                  </div>
                </div>
                <CardBody>
                  <Row
                    className="w-100 justify-content-center"
                    style={{ marginBottom: "190px" }}
                  >
                    <Col md={6} className="mb-4">
                      <Card>
                        {/* {JSON.stringify(form)} */}
                        <CardHeader
                          style={{ color: "#fff", backgroundColor: "#5295fa" }}
                        >
                          <h5 className="text-center">EXAMS SCORE</h5>
                        </CardHeader>
                        <CardBody>
                          <h1 className="text-center">Fail The Enterance</h1>
                          <h3 className="text-center">Exams</h3>
                          <h3 className="text-center">Try Agein Next Year </h3>
                          <Button
                            className="mt-5"
                            onClick={() =>
                              navigate(
                                "/entrance-exams-score/entrance-exams-score"
                              )
                            }
                          >
                            Ok
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </form>
          </div>
        </div>
        {/* </Container> */}
      </div>
    </div>
  );
}
